import type { Collectible } from '@/config/objects/collectibles';
import { useOutletContext } from 'react-router-dom';

interface CollectibleContext {
  collectible: Collectible | undefined;
  isLoading: boolean;
}

export function useCollectibleContext() {
  return useOutletContext<CollectibleContext>();
}
